module.exports = __webpack_public_path__ + "static/media/head-mapfre.416fd60c.png";